var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _scroller, _fill, _resizeObserver, _update;
class SlideshowProgress extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _scroller, null);
    __privateAdd(this, _fill, null);
    __privateAdd(this, _resizeObserver, null);
    __privateAdd(this, _update, () => {
      if (!__privateGet(this, _scroller) || !__privateGet(this, _fill)) return;
      const max = __privateGet(this, _scroller).scrollWidth - __privateGet(this, _scroller).clientWidth;
      const progress = Math.min(1, Math.max(0, max > 0 ? __privateGet(this, _scroller).scrollLeft / max : 0));
      const travel = Math.max(0, this.clientWidth - __privateGet(this, _fill).offsetWidth);
      __privateGet(this, _fill).style.transform = `translateX(${progress * travel}px)`;
    });
  }
  connectedCallback() {
    __privateSet(this, _scroller, this.closest(".resource-list__carousel")?.querySelector("slideshow-slides") ?? null);
    __privateSet(this, _fill, this.querySelector(".slideshow-controls__progress-fill"));
    if (!__privateGet(this, _scroller) || !__privateGet(this, _fill)) return;
    __privateGet(this, _scroller).addEventListener("scroll", __privateGet(this, _update), { passive: true });
    __privateSet(this, _resizeObserver, new ResizeObserver(__privateGet(this, _update)));
    __privateGet(this, _resizeObserver).observe(__privateGet(this, _scroller));
    __privateGet(this, _update).call(this);
  }
  disconnectedCallback() {
    __privateGet(this, _scroller)?.removeEventListener("scroll", __privateGet(this, _update));
    __privateGet(this, _resizeObserver)?.disconnect();
  }
}
_scroller = new WeakMap();
_fill = new WeakMap();
_resizeObserver = new WeakMap();
_update = new WeakMap();
if (!customElements.get("slideshow-progress")) {
  customElements.define("slideshow-progress", SlideshowProgress);
}
